/* prettier-ignore */
import { Directive, HostListener, inject } from '@angular/core';
import { DebugService } from 'src/app/services/debug.service';
import { RestService } from 'src/app/services/rest.service';
import { StatisticsService } from 'src/app/services/statistics.service';
import { ToolsService } from 'src/app/services/tools.service';
import { environment } from 'src/environments/environment';

@Directive({
  selector: 'ion-app'
})
export class BlurListenerDirective {
  private debugService = inject(DebugService);

  constructor(private tools: ToolsService, private stats: StatisticsService, private rest: RestService) {}

  @HostListener('window:blur', ['$event'])
  onBlur(event: FocusEvent) {
    if (!this.tools.showHeader() || !environment.production) 
      return;

    let currentTime = new Date().getTime();
    this.stats.sessionActiveTime = this.stats.sessionActiveTime + Math.round((currentTime - this.stats.lastSessionTime) /1000)
    this.stats.sessionTime = this.stats.sessionActiveTime
    this.stats.setSesh();
    const sesh = this.stats.sesh;
    this.debugService.debug(sesh, '[BlurStatsDirective] Sending stats');
    this.rest.sendStats(sesh).subscribe();
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: FocusEvent) {
    const currentTime = new Date().getTime();
    this.stats.lastSessionTime = currentTime;
  }
}